import { NgModule } from '@angular/core';

import { SpinnerComponent } from './spinner.component';

/**
 * @ignore
 */
@NgModule({
  declarations: [SpinnerComponent],
  imports: [],
  exports: [SpinnerComponent]
})
export class NguixDashboardSpinnerComponentModule {}
